
import { Component, OnInit, ViewChild} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {ComplementPaymentsDetailComponent} from '../complement-payments-detail/complement-payments-detail.component';
import {DatePipe} from '@angular/common';
import {ModalUploadComponent} from '../../modal-upload/modal-upload.component';
import * as decode from 'jwt-decode';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-complement-payments',
  templateUrl: './complement-payments.component.html',
  styleUrls: ['./complement-payments.component.scss']
})

///Pantalla de carga de facturas de complementos de pago.
export class ComplementPaymentsComponent implements OnInit {
  @ViewChild('fileInvView', { static: false }) fileInvView;
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  filterd: any = {};
  typeFileUpload: any;
  //step = 0;
  totalrows = 5150;
  loadBtn = false;
  tempSend: any = {};
  arra: any = [];
  listpayments = [];
  listSocieties = [];
  listPlanta = [];
  listPlantaSel = [];

  tmpProvider: any;

  arrOc = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];

  listTempData=[];

  providersList=[];
  step=0;

  myControl = new FormControl();
  filteredOptions: Observable<string[]>;

  providerActive = 'hide';

  perfilId;
  isExternal;

  listExport=[];

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService, public translate: TranslateService, private adapter: DateAdapter<any>) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');

    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;

    this.providerActive = (this.perfilId == '3' && this.isExternal )? 'hide': 'show';

    this.getSocieties();
    this.getPlantas();

    gralService.changeTextHead('CHARGECOMPLEMENTS');

    translate.onLangChange.subscribe(lang => {
      if(lang.lang == 'en'){
        this.adapter.setLocale('en-GB');
      }

      if(lang.lang == 'es'){
        this.adapter.setLocale('es-MX');
      }
    });
  }

  ngOnInit() {
    //setTimeout(()=>{ this.providerActive = (this.perfilId == '3' )? 'hide': 'show';} , 500)
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      this.data.FechaFin = new Date();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  loadProvidersSociety(society){
    this.provService.getProvidersNum(this.userToken, society).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);

        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos){

    if(this.perfilId==3){
      let List = this.listSocieties;
      this.arrOc = [];
      this.arrOc.push(List[pos].NumProveedor);
    }

    this.listPlantaSel = this.listPlanta.filter(x => x.IdSociedad == this.listSocieties[pos].IdSociedad || x.IdSociedad  == 0 );
    this.data.Plant = null;
  }

  getPlantas(){
    this.provService.getPlantas(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listPlanta = data['Entidades'];

      }else{
        this.listPlanta = null;
      }
    }, (err) => {

      this.loadBtn = false;
      this.listPlanta = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectPlanta(index){

    const planta = this.listPlanta[index];
    if(planta.NoPlanta){
      this.data.Plant = planta.BusArea;
    }
  }

  disabledProv(){
    let resp = false;

    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;

      }
    }
    return resp;
  }

  search(){
    this.listTempData = [];
    this.data.Proveedor = this.arrOc.join();

    if(!this.data.Proveedor || !this.data.Sociedad || !this.data.FechaInicio || !this.data.FechaFin){
      let body = "Favor de ingresar todos los campos";
      if(this.translate.currentLang == "es"){
        body = "Favor de ingresar todos los campos";
      }else if(this.translate.currentLang == "en"){
        body = "Please enter all fields";
      }
      this.toastr.error(body, 'Error');
      return;
    }

    this.step = 0;
    this.listpayments = null;
    this.listpayments = [];
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const dateinit = this.data.FechaInicio;
    const dateend = this.data.FechaFin;
    const params = {
      FechaFin: datePipe.transform(dateend, 'yyyy/MM/dd'),
      FechaInicio: datePipe.transform(dateinit, 'yyyy/MM/dd'),
      Proveedor: this.data.Proveedor,
      Sociedad: this.data.Sociedad,
      Planta : this.data.Plant
    };

    this.tempSend = params;

    this.provService.searchComplePayments(params, this.userToken).then((resp) => {
      this.loadBtn = false;
      if(resp['pagosCompensados']){
        this.listpayments = resp['pagosCompensados'].Items;
        this.step = 1;
        this.tmpProvider = this.data.Proveedor;
        this.filterDataExport(this.listpayments);
        //this.data = {};
      }else{
        let body = "Este complemento no tiene pagos";
        let title = "Complemento de pago";
        if(this.translate.currentLang == "es"){
          body = "Este complemento no tiene pagos";
          title = "Complemento de pago";
        }else if(this.translate.currentLang == "en"){
          body = "This complement has no payments";
          title = "Pay complement";
        }
        this.toastr.info(body, title);
        return;
      }
    }, (err) => {

      this.step = 0;
      this.listpayments = null;
      this.loadBtn = false;
      this.toastr.error(JSON.stringify(err), 'Error');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  detailDoc(rowInfo, proveedorId){
    this.tempSend.DocumentoCompensacion = rowInfo.CLR_DOC_NO;
    this.tempSend.Proveedor = rowInfo.VENDOR;
    //verifica si ya abrio una vez este detalle//
    //let noDoc = this.listpayments[idx].CLR_DOC_NO

    let validationTemp = this.existArray(rowInfo.CLR_DOC_NO);
    console.log(validationTemp);
    if(validationTemp.success == true){

      let itemTemp = validationTemp.doc;


      this.loadBtn = false;
        if(itemTemp['pagosCompensados']){
          this.arra = [];
        for(let g = 0; g < itemTemp['pagosCompensados'].Items.length; g++){
          this.arra.push(itemTemp['pagosCompensados'].Items[g]);
        }

        //this.arra.push(this.listpayments[idx]);
        this.arra.push(rowInfo);
          const params = {
            xmlBase64: null,
            pdfBase64: null,
            numeroProveedor: this.tempSend.Proveedor,
            numeroSociedad: this.data.Sociedad,
            claveEmpresa: 'SMP',
            tipoOrden: 5,
            pagoSAP: { Items: this.arra }
          };

          const dialogRef = this.dialog.open(ComplementPaymentsDetailComponent, {
            minWidth: '80%',
            position: {
              top: '6%'
            },
            data: {
              type: 'docs',
              info: itemTemp['pagosCompensados'].Items,
              total: itemTemp['pagosCompensados'].TotalPago, data: params
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if(result){
              console.log(result);
              if(result.status == 'update'){
                this.search();
              }
            }
          });
        }else{
          let body = "Este complemento no tiene pagos";
          let title = "Complemento de pago";
          if(this.translate.currentLang == "es"){
            body = "Este complemento no tiene pagos";
            title = "Complemento de pago";
          }else if(this.translate.currentLang == "en"){
            body = "This complement has no payments";
            title = "Pay complement";
          }
          this.toastr.info(body, title);
          return;
        }

    }else{
      this.loadBtn = true;

      this.provService.searchComplePaymentsDocs(this.tempSend, this.userToken).then((resp) => {
        this.arra = [];
        for(let g = 0; g < resp['pagosCompensados'].Items.length; g++){
          this.arra.push(resp['pagosCompensados'].Items[g]);
        }

        //this.arra.push(this.listpayments[idx]);
        this.arra.push(rowInfo);

        let temp = {};
          temp[rowInfo.CLR_DOC_NO] = resp;
          this.listTempData.push(temp );

        this.loadBtn = false;

        const params = {
          xmlBase64: null,
          pdfBase64: null,
          numeroProveedor:
          rowInfo.VENDOR,
          claveEmpresa: 'SMP',
          tipoOrden: 5,
          pagoSAP: {Items: this.arra}
        };


        if(resp['pagosCompensados']){
          const dialogRef = this.dialog.open(ComplementPaymentsDetailComponent, {
            minWidth: '80%',
            position: {
              top: '6%'
            },
            data: {
              type: 'docs',
              info: resp['pagosCompensados'].Items,
              total: resp['pagosCompensados'].TotalPago,
              data: params,
              sessionUserId: this.userId
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if(result){
              console.log(result);
              if(result.status == 'update'){
                this.search();
              }
            }
          });
        }else{
          let body = "Este complemento no tiene pagos";
          let title = "Complemento de pago";
          if(this.translate.currentLang == "es"){
            body = "Este complemento no tiene pagos";
            title = "Complemento de pago";
          }else if(this.translate.currentLang == "en"){
            body = "This complement has no payments";
            title = "Pay complement";
          }
          this.toastr.info(body, title);
          return;
        }
      }, (err) => {
        this.step = 0;
        this.listpayments = null;
        this.loadBtn = false;
        this.toastr.error(JSON.stringify(err), 'Error');
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }
      });
    }

  }

  existArray(noDoc){
    let Docs = this.listTempData;
    for(let i = 0; i < Docs.length; i++ ){
      if(Docs[i][noDoc]){
        return {success: true, doc: Docs[i][noDoc]  };
      }
    }

    return {success:false, doc: null};

  }

  uploadInvoice(id, idx){

    let noDoc = this.listpayments[idx].CLR_DOC_NO

    this.tempSend.DocumentoCompensacion = this.listpayments[idx].CLR_DOC_NO;
    this.loadBtn = true;

    // valida si ya esta en lista temporal //
    if(this.listTempData != undefined && this.listTempData[noDoc] ){
      console.log('ya esta en la lista temporal');
    }else{ // si no existe datos temporales  corre la consulta//
      this.provService.searchComplePaymentsDocs(this.tempSend, this.userToken).then((resp) => {
        let temp = {};
        temp[noDoc] = resp;
        this.listTempData.push(temp );
        this.listTempData[noDoc] = [];
        // llena lista temporal //
        this.listTempData[noDoc].push(resp['pagosCompensados']);
        this.loadBtn = false;
        if(resp['pagosCompensados']){
          this.arra = [];
          for(let g = 0; g < resp['pagosCompensados'].Items.length; g++){
            this.arra.push(resp['pagosCompensados'].Items[g]);
          }

          this.arra.push(this.listpayments[idx]);

          //const params = {xmlBase64: null, pdfBase64: null, numeroProveedor: this.tmpProvider, claveEmpresa: 'SMP', tipoOrden: 5, pagoSAP: {Items: this.arra}};
          const params = {
            xmlBase64: null,
            pdfBase64: null,
            numeroProveedor: this.listpayments[idx].VENDOR,
            numeroSociedad: this.data.Sociedad,
            claveEmpresa: 'SMP',
            tipoOrden: 5, pagoSAP: { Items: this.arra }
          };

          const dialogRef = this.dialog.open(ModalUploadComponent, {
            minWidth: '70%',
            position: {
              top: '6%'
            },
            data: { type: 'complement', data: params }
          });

          dialogRef.afterClosed().subscribe(result => {
            if(result){
              this.data = {};
              this.step = 0;
              this.listpayments = null;
              this.arra = [];
              this.temp = null;
            }
          });
        }else{
          let body = "Este complemento no tiene pagos";
          let title = "Complemento de pago";
          if(this.translate.currentLang == "es"){
            body = "Este complemento no tiene pagos";
            title = "Complemento de pago";
          }else if(this.translate.currentLang == "en"){
            body = "This complement has no payments";
            title = "Pay complement";
          }
          this.toastr.info(body, title);
          return;
        }
      }, (err) => {
        console.log(err);
        this.step = 0;
        this.listpayments = null;
        this.loadBtn = false;
        this.toastr.error(JSON.stringify(err), 'Error');
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }
      });
    }

  }

  detailPayments(id, idx){
    const dialogRef = this.dialog.open(ComplementPaymentsDetailComponent, {
      minWidth: '80%',
      position: {
        top: '6%'
      },
      data: { type: 'detail', id: id, info: this.listpayments[idx] }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
        if(result.status == 'update'){
          this.search();
        }
      }
    });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }

  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listpayments);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExport);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('complemento_pagos'));
  }


  filterDataExport(obj){
    this.listExport = [];
    for(let i = 0; i < obj.length; i++ ){
      let objInclude = {  "Proveedor":      obj[i].VENDOR ,
                          "Sociedad":       obj[i].COMP_CODE,
                          "No. documento":  obj[i].CLR_DOC_NO,
                          "Planta"      :   obj[i].BUS_AREA,
                          "Referencia":     obj[i].REF_DOC_NO,
                          "Fecha pago":     obj[i].DOC_DATE,
                          "importe":        obj[i].AMT_DOCCUR_DEC,
                          "Moneda":         obj[i].CURRENCY,
                          "Tipo cambio":    obj[i].EXCHANGE_RATE,
                          "Bus Area" :      obj[i].BUS_AREA
                        };
      this.listExport.push(objInclude);
    }
  }


}
